import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import ContentLoader from 'react-content-loader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const QuestionLoader = props => {
  const {
    layout
  } = props;

  if (['number', 'text', 'money', 'select', 'duration'].includes(layout)) {
    return /*#__PURE__*/_jsx(InputLoader, _objectSpread({}, props));
  }

  if (layout === 'checkbox') {
    return /*#__PURE__*/_jsx(CheckboxLoader, _objectSpread({}, props));
  }

  if (layout === 'radio') {
    return /*#__PURE__*/_jsx(RadioLoader, _objectSpread({}, props));
  }

  if (layout === 'radioButtons') {
    return /*#__PURE__*/_jsx(RadioButtonsLoader, _objectSpread({}, props));
  }

  if (layout === 'slider') {
    return /*#__PURE__*/_jsx(SliderLoader, _objectSpread({}, props));
  }

  return null;
};

const InputLoader = _ref => {
  let {
    dataset,
    className
  } = _ref;
  return /*#__PURE__*/_jsxs(ContentLoader, _objectSpread(_objectSpread(_objectSpread({
    height: 75,
    width: "100%"
  }, dataset && _objectSpread({}, dataset)), className && {
    className
  }), {}, {
    children: [/*#__PURE__*/_jsx("rect", {
      x: "0",
      y: "0",
      rx: "3",
      ry: "3",
      width: "40%",
      height: "15"
    }), /*#__PURE__*/_jsx("rect", {
      x: "0",
      y: "25",
      rx: "3",
      ry: "3",
      width: "100%",
      height: "50"
    })]
  }));
};

const CheckboxLoader = _ref2 => {
  let {
    dataset,
    className
  } = _ref2;
  return /*#__PURE__*/_jsxs(ContentLoader, _objectSpread(_objectSpread(_objectSpread({
    width: "100%",
    height: 45
  }, dataset && _objectSpread({}, dataset)), className && {
    className
  }), {}, {
    children: [/*#__PURE__*/_jsx("rect", {
      x: "0",
      y: "0",
      rx: "3",
      ry: "3",
      width: "40%",
      height: "15"
    }), /*#__PURE__*/_jsx("rect", {
      x: "0",
      y: "25",
      rx: "3",
      ry: "3",
      width: "18",
      height: "18"
    }), /*#__PURE__*/_jsx("rect", {
      x: "28",
      y: "25",
      rx: "3",
      ry: "3",
      width: "80%",
      height: "18"
    })]
  }));
};

const RadioLoader = _ref3 => {
  let {
    dataset,
    className
  } = _ref3;
  return /*#__PURE__*/_jsxs(ContentLoader, _objectSpread(_objectSpread(_objectSpread({
    width: "100%",
    height: 45
  }, dataset && _objectSpread({}, dataset)), className && {
    className
  }), {}, {
    children: [/*#__PURE__*/_jsx("rect", {
      x: "0",
      y: "0",
      rx: "3",
      ry: "3",
      width: "40%",
      height: "15"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "9",
      cy: "34",
      r: "9"
    }), /*#__PURE__*/_jsx("rect", {
      x: "28",
      y: "25",
      rx: "3",
      ry: "3",
      width: "80%",
      height: "18"
    })]
  }));
};

const RadioButtonsLoader = _ref4 => {
  let {
    dataset,
    className
  } = _ref4;
  return /*#__PURE__*/_jsxs(ContentLoader, _objectSpread(_objectSpread(_objectSpread({
    width: "100%",
    height: 59
  }, dataset && _objectSpread({}, dataset)), className && {
    className
  }), {}, {
    children: [/*#__PURE__*/_jsx("rect", {
      x: "0",
      y: "0",
      rx: "3",
      ry: "3",
      width: "40%",
      height: "15"
    }), /*#__PURE__*/_jsx("rect", {
      x: "0",
      y: "25",
      rx: "3",
      ry: "3",
      width: "100%",
      height: "34"
    })]
  }));
};

const SliderLoader = _ref5 => {
  let {
    dataset,
    className
  } = _ref5;
  return /*#__PURE__*/_jsxs(ContentLoader, _objectSpread(_objectSpread(_objectSpread({
    width: "100%",
    height: 59
  }, dataset && _objectSpread({}, dataset)), className && {
    className
  }), {}, {
    children: [/*#__PURE__*/_jsx("rect", {
      x: "0",
      y: "0",
      rx: "3",
      ry: "3",
      width: "40%",
      height: "15"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "7",
      cy: "34",
      r: "7"
    }), /*#__PURE__*/_jsx("rect", {
      x: "0",
      y: "32",
      rx: "3",
      ry: "3",
      width: "100%",
      height: "4"
    })]
  }));
};

export default QuestionLoader;